// extracted by mini-css-extract-plugin
module.exports = {"change-password-form":"styles_change-password-form__BFz54","form":"styles_form__2I6Fi","form-wrapper":"styles_form-wrapper__1VbOp","input":"styles_input__25lXM"};